import { Quote, Trophy } from "lucide-react";

const stats = [
  { n: "5,400+", l: "Students Trained" },
  { n: "93%", l: "Placement Rate" },
  { n: "₹3.6L", l: "Average Starting Package" },
  { n: "27+", l: "Hiring Partners" },
];

const stories = [
  { name: "Sahil Khan", role: "Service Engineer · BPL Medical", quote: "I'm a B.Sc graduate. BIOMAC gave me a real direction. Got placed within 3 weeks of finishing the course." },
  { name: "Megha Reddy", role: "Application Specialist · GE Healthcare", quote: "The mock interviews were exactly like the real one. The value BIOMAC delivers is unmatched for a 45-day course." },
  { name: "Vivek Patil", role: "Biomedical Engineer · Apollo Hospitals", quote: "Switched from a non-medical engineering job. BIOMAC simplified everything in 15 days." },
];

const partners = [
  "GE Healthcare", "Philips", "Siemens", "Trivitron", "BPL", "Apollo Hospitals",
  "Fortis", "Manipal", "Mindray", "Drager", "Skanray", "Wipro GE",
];

export const Placements = () => (
  <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20" data-testid="placements-page">
    <span className="eyebrow">Placements & Outcomes</span>
    <h1 className="mt-4 font-heading text-5xl sm:text-6xl font-semibold text-[#0A3B32] tracking-tight max-w-4xl">
      Our students don't just complete the course. They get hired.
    </h1>

    <div className="mt-12 grid grid-cols-2 md:grid-cols-4 gap-4">
      {stats.map((s, i) => (
        <div key={s.l} className="card-soft text-center" data-testid={`placement-stat-${i}`}>
          <Trophy className="mx-auto text-[#C85A40]" />
          <p className="mt-3 font-heading text-3xl font-bold text-[#0A3B32]">{s.n}</p>
          <p className="mt-1 text-xs text-slate-500">{s.l}</p>
        </div>
      ))}
    </div>

    <div className="mt-20">
      <h2 className="font-heading text-3xl font-semibold text-[#0A3B32]">Student Stories</h2>
      <div className="mt-8 grid md:grid-cols-3 gap-6">
        {stories.map((s, i) => (
          <div key={s.name} className="card-soft" data-testid={`story-${i}`}>
            <Quote className="text-[#C85A40]" />
            <p className="mt-4 text-slate-700 leading-relaxed italic">"{s.quote}"</p>
            <div className="mt-5 border-t border-slate-100 pt-4">
              <p className="font-heading font-semibold text-[#0A3B32]">{s.name}</p>
              <p className="text-xs text-slate-500">{s.role}</p>
            </div>
          </div>
        ))}
      </div>
    </div>

    <div className="mt-20">
      <h2 className="font-heading text-3xl font-semibold text-[#0A3B32]">Hiring Partners</h2>
      <div className="mt-8 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3">
        {partners.map((p) => (
          <div key={p} className="bg-white border border-slate-200 rounded-xl px-4 py-4 text-center font-medium text-slate-700 text-sm">
            {p}
          </div>
        ))}
      </div>
    </div>
  </div>
);
